import { render, staticRenderFns } from "./EditGlobalRate.vue?vue&type=template&id=0be8702e"
import script from "./EditGlobalRate.vue?vue&type=script&lang=js"
export * from "./EditGlobalRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports